import { render, staticRenderFns } from "./wizard.vue?vue&type=template&id=b445056e&scoped=true&lang=pug&"
import script from "./wizard.vue?vue&type=script&lang=ts&"
export * from "./wizard.vue?vue&type=script&lang=ts&"
import style0 from "./wizard.vue?vue&type=style&index=0&id=b445056e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b445056e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
installComponents(component, {VStepper,VStepperContent,VStepperItems})
